import React from "react";
import { createRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

// `<div id="root">` is always empty at page load — our prerender injects
// SEO fallback content into a separate <div> before </body>, not inside root,
// so no hydration is needed. createRoot avoids the React #418 mismatch
// error that used to force a full client re-render (~200 ms of JS time).
const rootElement = document.getElementById("root");
createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
